// Around 200_000 rows of data (drivers)
export const MAX_FILE_SIZE_BYTES = 10_000_000;
